"use strict";

import { Constants } from "customer-sdk/constants";
const { PAYMENT_i18n_LABELS } = Constants.PAYMENT;
const NUMBER_EXTRACTOR = /(\d[\d.]*)/g;
const BASE_COMPANY_SEC = /^Company Secretary \(([0-9]+) Shareholder/i;
const MULTIPLE_COMPANY_SEC = /^Company Secretary \(([0-9]+) to ([0-9]+) Shareholder/i;
const BASE_CORP_SEC = /^Corporate Secretary \(([0-9]+) Shareholder/i;
const MULTIPLE_CORP_SEC = /^Corporate Secretary \(([0-9]+) to ([0-9]+) Shareholder/i;
const ACCOUNTING_PLAN = /^Accounting Plan - Up to/i;
const HKG_DOLLARS = /^HK\$/i;
const NEGATIVE_HKG_DOLLARS = /^HK\$-/i;

/**
 * Will try to match the following values respectively
 * - S$1.5K
 * - S$10k
 * - HKD 700k
 * - HKD 1.5k
 * from
 * Accounting Plan - Up to S$1.5K Monthly Expenses
 * Accounting Plan - Up to S$10K Monthly Expenses
 * Accounting Plan - Up to HKD 700K Monthly Expenses
 * Accounting Plan - Up to HKD 1.5K Monthly Expenses
 */
const SHORT_HAND_PRICE = /((S\$)|(HKD ))[0-9]+(\d*(\.\d+))?K/g;

export const PaymentLocaleMixin = {
  methods: {
    GET_ACCOUNTING_SUBSCRIPTION_LABEL(name) {
      const cleanName = String(name).trim();
      if (ACCOUNTING_PLAN.test(cleanName)) {
        const [planPrice] = cleanName.match(SHORT_HAND_PRICE);
        if (planPrice) {
          return this.$t("$onboarding.content_paragraph.payment.summary.packages.general.accounting_plan", {
            act_fee: planPrice,
          });
        }
      }
    },
    GET_CORPSEC_SUBSCRIPTION_LABEL(name) {
      const cleanName = String(name).trim();
      const isCompanySec = BASE_COMPANY_SEC.test(cleanName);
      const isCorpSec = BASE_CORP_SEC.test(cleanName);
      if (isCompanySec || isCorpSec) {
        const [shareholderCount] = cleanName.match(NUMBER_EXTRACTOR);
        const transId = isCompanySec
          ? "$onboarding.content_paragraph.payment.summary.packages.hkg.corp_sec"
          : "$onboarding.content_paragraph.payment.summary.packages.sgp.corp_sec";

        return this.$tc(transId, shareholderCount, {
          count: shareholderCount,
        }).replace("\n", "<br/>");
      }
    },
    GET_MULTIPLE_CORPSEC_SUBSCRIPTION_LABEL(name) {
      const cleanName = String(name).trim();
      const isMultipleCompanySec = MULTIPLE_COMPANY_SEC.test(cleanName);
      const isMultipleCorpSec = MULTIPLE_CORP_SEC.test(cleanName);
      if (isMultipleCompanySec || isMultipleCorpSec) {
        const [fromCount, toCount] = cleanName.match(NUMBER_EXTRACTOR);
        const transId = isMultipleCompanySec
          ? "$onboarding.content_paragraph.payment.summary.packages.hkg.multiple_corp_sec"
          : "$onboarding.content_paragraph.payment.summary.packages.sgp.multiple_corp_sec";

        return this.$t(transId, {
          from_num: fromCount,
          to_num: toCount,
        }).replace("\n", "<br/>");
      }
    },
    GET_PAYMENT_LOCALE_LABEL(name) {
      try {
        const cleanName = String(name).trim();

        const corpsecLabel = this.GET_CORPSEC_SUBSCRIPTION_LABEL(name);
        if (corpsecLabel) return corpsecLabel;

        const multipleCorpsecLabel = this.GET_MULTIPLE_CORPSEC_SUBSCRIPTION_LABEL(name);
        if (multipleCorpsecLabel) return multipleCorpsecLabel;

        const accountingLabel = this.GET_ACCOUNTING_SUBSCRIPTION_LABEL(name);
        if (accountingLabel) return accountingLabel;

        const matched = PAYMENT_i18n_LABELS[cleanName];
        if (matched) return this.$t(matched).replace("\n", "<br/>");

        return name.replace("\n", "<br/>");
      } catch (error) {
        console.error(error);
        return name;
      }
    },
    FORMAT_LOCALE_PRICE(amount, boldPrice = false) {
      if (HKG_DOLLARS.test(amount)) {
        const prices = amount.match(NUMBER_EXTRACTOR);
        const price = prices && prices.join(",");
        const isNegative = NEGATIVE_HKG_DOLLARS.test(amount);
        return this.$t("$onboarding.content_paragraph.payment.summary.packages.hkg.price", {
          prefix: isNegative ? "-" : "",
          amount: boldPrice ? `<b>${price}</b>` : price,
        });
      } else {
        return amount;
      }
    },
    // Remove when Dollar Value price for Accounting Slider is translated
    FORMAT_LOCALE_PRICE_NOT_TRANSLATED(amount, boldPrice = false) {
      if (HKG_DOLLARS.test(amount)) {
        const prices = amount.match(NUMBER_EXTRACTOR);
        const price = prices && prices.join(",");
        const isNegative = NEGATIVE_HKG_DOLLARS.test(amount);
        return `HK$${isNegative ? "-" : ""}${boldPrice ? `<b>${price}</b>` : price}`;
      } else {
        return amount;
      }
    },
    FORMAT_LOCALE_SHORTHAND_PRICE(amount) {
      if (HKG_DOLLARS.test(amount)) {
        const [price] = amount.match(NUMBER_EXTRACTOR);
        if (price) {
          return this.$t("$onboarding.content_paragraph.payment.summary.packages.hkg.price_shorthand", {
            amount: price,
          });
        }
      }
      return amount;
    },
  },
};
